import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Paper,
  Box,
  Button,
  Divider,
  Card,
  CardContent,
  Grid,
  Chip
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CircleIcon from '@mui/icons-material/Circle';

export const ChronicleReform = () => {
  const navigate = useNavigate();

  const timelineEvents = [
    {
      date: "1. Januar 1994",
      title: "Bahnreform tritt in Kraft",
      description: "Deutsche Bundesbahn wird zur Deutsche Bahn AG",
      color: "primary"
    },
    {
      date: "1994-1995",
      title: "Regionalisierung",
      description: "Übertragung des Nahverkehrs an die Bundesländer",
      color: "secondary"
    },
    {
      date: "1996",
      title: "Gründung DB Regio",
      description: "Entstehung regionaler Verkehrsgesellschaften",
      color: "success"
    }
  ];

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate('/chronicles')}
        sx={{ mb: 3 }}
      >
        Zurück zur Chronik
      </Button>

      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ color: '#E30613' }}>
          Die Bahnreform und Regionalisierung
        </Typography>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          1994-1996: Vom Staatsbetrieb zum modernen ÖPNV
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.7 }}>
          Die deutsche Bahnreform von 1994 war eine der größten Strukturreformen in der deutschen 
          Verkehrsgeschichte. Sie legte den Grundstein für die Entstehung moderner, regionaler 
          Verkehrsunternehmen wie DB Regio Bus Mitte.
        </Typography>

        {/* Custom Timeline */}
        <Box sx={{ my: 4 }}>
          <Typography variant="h6" gutterBottom sx={{ color: '#E30613', mb: 3 }}>
            Wichtige Meilensteine
          </Typography>
          
          {timelineEvents.map((event, index) => (
            <Card key={index} sx={{ mb: 2, position: 'relative' }}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', pt: 0.5 }}>
                    <CircleIcon 
                      color={event.color} 
                      sx={{ fontSize: 16 }}
                    />
                    {index < timelineEvents.length - 1 && (
                      <Box sx={{ 
                        width: 2, 
                        height: 40, 
                        backgroundColor: '#ddd', 
                        mt: 1 
                      }} />
                    )}
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Chip 
                      label={event.date} 
                      size="small" 
                      color={event.color}
                      variant="outlined"
                      sx={{ mb: 1 }}
                    />
                    <Typography variant="h6" gutterBottom>
                      {event.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {event.description}
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          ))}
        </Box>

        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.7 }}>
          Das Regionalisierungsgesetz übertrug die Verantwortung für den Schienenpersonennahverkehr 
          (SPNV) von der Bundesebene auf die Länder. Hessen nutzte diese Chance, um ein integriertes 
          Verkehrssystem zu entwickeln, in dem Bus und Bahn optimal zusammenwirken.
        </Typography>

        <Card sx={{ my: 3, backgroundColor: '#f5f5f5' }}>
          <CardContent>
            <Typography variant="h6" gutterBottom color="primary">
              Auswirkungen auf den Busverkehr
            </Typography>
            <Typography variant="body1">
              • Bessere Abstimmung zwischen Bus und Bahn<br />
              • Einheitliche Tarife und Fahrkarten<br />
              • Optimierte Fahrpläne und Anschlüsse<br />
              • Erhöhte Investitionen in moderne Fahrzeuge
            </Typography>
          </CardContent>
        </Card>

        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.7 }}>
          Für DB Regio Bus Mitte bedeutete die Reform eine große Chance: Als Teil der Deutschen Bahn 
          konnte das Unternehmen von Synergien profitieren und gleichzeitig flexibel auf regionale 
          Bedürfnisse eingehen. Die enge Verzahnung mit dem Schienennetz ermöglichte es, 
          attraktive Gesamtverbindungen anzubieten.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Card sx={{ backgroundColor: '#e3f2fd' }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Quellen:
            </Typography>
            <Typography variant="body2" component="div">
              • Bundestag-Drucksache 12/5015: "Gesetz zur Neuordnung des Eisenbahnwesens"<br />
              • Hessisches Ministerium für Wirtschaft und Verkehr: Regionalisierung des ÖPNV<br />
              • Deutsche Bahn AG: "25 Jahre Bahnreform" - Jubiläumsschrift (2019)<br />
              • VCD (Verkehrsclub Deutschland): "ÖPNV-Chronik Deutschland"
            </Typography>
          </CardContent>
        </Card>
      </Paper>
    </Container>
  );
};

export default ChronicleReform;